import React from "react";
//css
import './CookiePolicy.css';

const Privacy = () => {

  return (
    <div className="policy_section">
      <div className="policy_left">
        <p>TERMS | PRIVACY</p>
        <span>Dated: 4th September’ 2021</span>
      </div>
      <div className="policy_right">
        <span className="policy_cancellation">Terms Of Service</span>
        <p>
          Welcome to NeuroLingua, this is the website that facilitates students
          to find teachers. From now on it will be referred to as "NeuroLingua
          ", "we," or "us". <br/><br/>This page explains the terms by which you may use
          our online services, website, and software provided on or in
          connection with the service, collectively referred to as the
          "Service".
        </p>
        <p>
          NeuroLingua is an online platform that brings teachers and students
          together. It facilitates a safe environment for students to receive
          services from the tutors and issue the payments safely. Since it is an
          online one-on-one lesson platform, you can do lessons that suit your
          level, needs, and interest with a teacher that suits you.
        </p>
        <span>Relationship with NeuroLingua</span>
        <p>
          The NeuroLingua Platform is an online venue for language learning
          where registered users may use our Connection Services and Payment
          Services to directly interact with one another. If you choose to teach
          on the NeuroLingua Platform, you understand and agree that your
          relationship with NeuroLingua is as a contracted tutor and brand
          ambassador.
        </p>
        <span>Code of Conduct for teachers</span>
        <p>Tutors of NeuroLingua are expected</p>
        <p>
          - To be a brand ambassador
          <br />
          - To be willing to help
          <br />
          - To be professional
          <br />
          - To be punctual
          <br />
          - To respond quickly
          <br />
          - To have a good relationship with the student
          <br />
          - To dedicate the best of their efforts in fulfilling their duty as tutors, thereby promoting student retention.
          <br />
        </p>
        <span>Offenses</span>
        <p>
          The following actions are not permitted on NeuroLingua and may lead to
          account deactivation and removal from the platform:
        </p>
        <p>
          1. Scheduling and giving sessions to fake students or with yourself.
          <br />
          <br />
          2. Any attempt to send or receive money off platform, from the students or teachers engaged with the website.
          <br />
          <br />
          3. Any attempt to enlist the students or teachers to study or work on competing platforms, websites or schools.
          <br />
          <br />
          4. Sending or requesting Neurolingua teacher or student to share their Facebook, Instagram, WhatsApp, Skype IDs, email, phone numbers or any other personal contact information.
          <br />
          <br />
          5. Conducting any sessions off the platform without prior written permission from Neurolingua or its officially authorized representatives.
          <br />
          <br />
          6. Sexually coloured remarks, nudity, romantic/sexual advances and/or attempts to use the website as a dating website.
          <br />
          <br />
          7. Using abusive, offensive language, threats or bullying teachers or students using the website.
          <br />
          <br />
          8. Frequently asking for free sessions and services.
          <br />
          <br />
          9. Spamming mails or messages to teachers or students from the website.
          <br />
          <br />
          10. Performing fraudulent activities such as using fake credit cards or other payment methods.
          <br />
          <br />
          11. Identity fraud
          <br />
          <br/>
          12. Engaging in money laundering or theft on the website.
        </p>

        <br />
        <span className>Trials</span>
        <br />
        <br />
        <p>
        Every student is 3 silver tickets upon logging into the platform for the first time after
        registration. Each silver ticket is worth one 30-minute trial class. Students can use
        these tickets to book trials with 3 different teachers.
        </p>
        <p>
        If a student decides to continue with the first teacher, they have had the trial session
        with, the remaining silver tickets can be traded in for a 3 US Dollar discount per
        ticket, for their subsequent sessions. Tickets that are not redeemed will expire within
        60 days.
        </p>
        <p>
        If a student wishes to avail more trial sessions after exhausting all three silver tickets,
        additional tickets may be purchased, at the cost of 3 US Dollars per ticket.
        </p>
        <span className>Wallet Coins and Tickets</span>
        <p>In NeuroLingua, you can have other means of purchasing classes.</p>
        <p>
          <b>a.Tickets</b>
        </p>
        <p>
          <b>Silver Ticket:</b> - Each silver ticket is worth 1 trial class.
          <br /> - Each silver ticket is worth 5 dollars.
        </p>
        <p>
          <b>b. Coins</b>
        </p>
        <p>
          <b>Wallet Coins</b>: 1000 Coins is worth 1 USD. Wallet coins can be
          used in purchasing classes. They can be earned by;
          <br /> - Direct purchasing - Redeeming seasonal gifts
          <br /> - Level-ups (each level up is worth 100 coins)
          <br /> - Teacher give away (a teacher can share coins to favor the
          student, a teacher can give away a maximum of 100 coins per student,
          only after completing 11th hour)
          <br /> - Gift cards (friends can purchase coins for each other)
          <br /> - Transferring from the app
        </p>
        <p>
          1:- what is class fee <br />
          Class fee is the price of the class that is booked. This is the amount
          decided by your teacher. 2 platform fee <br />
          Platform fee is the tiny cost you see in the payment page. We use it
          for vetting the teachers and running the platform.
          <br />
          3:- 30 days refund <br />
          <br />
          4:- student agreement guidelines
        </p>
        <br/>
        <br />
        <span className="policy_cancellation">Privacy Policy</span>
        <p>
          NeuroLingua (neurolingua.in), hereinafter referred to as the “Site”, “us”, “we” or “our” has adopted this Privacy Policy to protect the privacy of its website users. The following Privacy Policy is only in effect for the web pages and mobile applications created by us. This policy describes how we collect and use your Personal Identifiable Information in accordance with the Information Technology (Reasonable Security Practices and Procedure and Sensitive Personal Data or Information) Rules, 2011, General Data Protection Regulation (“GDPR”) and laws of the State of Delaware, USA all other applicable laws.
        </p>
        <br />
        By using this Site, you agree to this Privacy Policy. This Privacy Policy is in effect from (14th October, 2021)
        <br/><br/><br/>
        <span>Acceptance of this Privacy Policy</span>
        <p>
          By accessing and using our Services, you signify your acceptance to the terms of this Privacy Policy. Where we require your consent to process your personal information, we will ask for your consent to the collection, use, and disclosure of your personal information as described further below.
          <br/><br/>
          If you do not consent to such usage or you are not comfortable with any aspect of this Privacy Policy, you should immediately discontinue access or use of our Services and Site. If you continue accessing our Site further, it shall be deemed that you have given us your consent.
          <br/><br/>
          What Data or Information do we collect?
          <br/><br/>
          When you register or subscribe to our Service, as a tutor or student, we collect your personal information that can identify you (“Personal Identifiable Information” or “PII”) including, but not limited to, your name, personal identification number, address, mobile number, email address.
          <br/><br/>
          We also collect your PII when you participate in forum, survey, contact us, comment, creating profile or rating.
          <br/><br/>
          Usage of your information is solely for the purpose of giving you the best services and experience on our Site.
          <br/><br/>
          The Site does not collect any detailed personal data or information that are sensitive (“Sensitive Personal Information”) such as password, financial information, physical, physiological, and mental health conditions, or biometric information.
          <br/><br/>
          You will be required to provide payment (eg. Credit card details) and billing information to make payment through various payment methods, this information will be processed encrypted and in a secure manner by third-party payment services. We do not store your payment information on our servers.
          <br/><br/>
          We also collect details of transactions carried out through our Site, including without limitations, ID, date and time of transactions.
          <br/><br/>
          When you visit our Site from your mobile device, we get information about your geographical location, however, you can prevent the location data from being sent to us, by denying access to your location.
          <br/><br/>
          When you visit our Site, our server automatically collects information form your browser such as IP address, proxy server, operating system, web browser and add-ons, device identifier and features, and/or ISP or your mobile carrier, or the domain from which you are visiting, web-pages you visit, the search terms you use, and any advertisements on which you click.
          <br /><br />
          How do we use the data or information collected by our Site?
          <br /><br />
          <p>- The data collected is used for the purpose for which it has been provided, including without limitation, to enable us to process and fulfil your subscriptions or other requests.</p>
          <p>- To identify you so as to ease out the re-login process at a later time.</p>
          <p>- To notify you about our Services.</p>
          <p>- To gather feedback, to ask you to participate in research to improve your experience of our Services.</p>
          <p>- To send you information about your relationship or transactions with us.</p>
          <p>- To personalise the content that interests you and notify you about the same.</p>
          <p>- To develop or update features, products and services according to the likes and needs of our customers.</p>
          <p>- To allow other select companies to send you promotional information about their products and services.</p>
          <p>- To provide customer support and respond to your request, inquiries and compliant.</p>
          <p>- To deter against fraudulent, unauthorized and illegal activity.</p>
        </p>
        <br />
        <span>Usage of Cookies</span>
        <p>
          We use “Cookies” to collect additional website usage data and improve the Site and our services. To analyse trends, administer the Site, track visitor’s movement and measure the number of visitors on various sections of site so that the Site becomes more meaningful to the visitors.
          <br />
          You can view our Cookie Policy on the following link:<a href="https://live.neurolingua.in/cookies"> https://live.neurolingua.in/cookies </a>
        </p>
        <br />
        <span>Third Party Data Collection</span>
        <br/>
        <p>
          We may share your data with third-party who provide services on our behalf such as for administrative purposes, data analysis and for making payment.
        </p>
        <p>All our third-party service provider is required to take appropriate security measures to protect your data.</p>
        <p>We do not allow any third-party to use your data for their own purposes.</p>
        <p>We permit them to process your data in accordance with our instructions.</p>
        <p>By consenting to this Privacy Policy, you consent to share your data with third-party service providers.</p>
        <p>We may display third-party content on the website, including third-party advertising.</p>
        <p>Third-party content may use cookies, web beacons, or other mechanism to track your views on the third-party website.</p>
        <p>We may implement third-party button including, but not limited to facebook, LinkedIn, twitter, etc share buttons, which may function as a web beacon.</p>
        <p>We may process your information on our mailing list or for the newsletter and send you messages with some commercial or promotional information about our Services. However, you have option to opt-out from our marketing messages by contacting us at <a href="mailto:support@neurolingua.in">support@neurolingua.in</a></p>
        <p>This Site is not responsible for information collected by any third-party web-beacons and buttons. You may consult such third-party’s data collection, use and disclosure policies for more information.</p>
        <p>This Site is not responsible for the content, privacy and security practices, and policies of third-party sites or services linked to this Site.</p>
        
        <span>User Discretion and Opt-out</span>
        <p>If you do not wish to share your data with us, you can contact us at support@neurolingua.in requesting to stop sharing your data.</p>
        <p>In the event you wish to opt-out of our data collection process by requesting us to stop accessing your data, you will no longer be able to access our Site and Services.</p>

        <span>Data Storage and Deletion</span>
        <p>Your personal data is stored with utmost security in accordance with the provision set out under Information Technology Act, 2008, Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011 and on protection of natural persons with regard to the processing of personal data the General Data Protection Regulation (“GDPR”) and laws of the State of Delaware, USA all other applicable laws.</p>
        <p>We store your data only as long as necessary to provide you with our Services and other legitimate business purposes including but not limited to, maintaining performance of the services or in compliance with the legal proceedings and requirements.</p>
        <p>We may retain your data as long as your account is active, once you have deleted or completed your course, we will no longer store your information with us.</p>
        <p>We may retain some of your data even after the expiration of your term or deletion of your account, in the event including, but not limited to unresolved issues, law enforcement, fraud prevention, etc.</p>
        <p>You may request us, in writing to delete all your data from our Site at support@neurolingua.in all your data will be deleted within 90 days of such request and will not be available with us anymore.</p>

        <span>Cross Border transfer</span>
        <p>We may process your personal data both within United States and outside the United States. Although countries where we process data may have different laws, we take measures to ensure high privacy compliance the applicable laws and are used for the purpose specified in this Privacy Policy</p>
        
        <span>Children’s Privacy</span>
        <p>This Site is not intended to be used by children under the age of 18 years without express permission of their parent or legal guardian.</p>
        <p>We may process the personal data of children under the age of 18, provided the data has been provided with the consent and under the supervision of the parents or legal guardians.</p>
        <p>Neurolingua is in compliance with Children’s Online Privacy Protection Rule (“COPPA) which requires us to inform parents and legal guardians about how we collect, use, and disclose personal information form children under the age of 13.</p>
        <p>We do not knowingly collect information from children and minors.</p>

        <span>Breach Notifications</span>
        <p>If any of your personal data has been breached, we would inform you and the respective data protection agencies as to the accidents without any undue delay, if there are high risks of violation of your rights as data subject. We would do our best to minimize any such risks.</p>
        
        <span>Grievances</span>
        <p>We hope that this Privacy Policy has helped you understand how your personal data will be dealt with at neurolingua.in We will take care of your personal data, so you can use our Services without feared of any privacy issues.</p>
        <p>If you wish to contact us for any grievance regarding our Privacy Policy, you can email your grievance at support@neurolingua.in Or write to us at: 503, Sirisampada Hi-Tech, Road No. 36, Kavuri Hills, Jubli Hills, Hyderabad, Telanagana, India – 500033.</p>
        <p>We will seek to redress your grievance without any undue delay and in accordance with the requirement of the applicable law.</p>

        <span>Privacy Agreement for Users</span>
        <p>During their tenure with NeuroLingua, teachers and students, hereinafter referred to as “Party” may not disclose or make available to any third Party (“Recipient”) Confidential Information, whether orally or in writing, electronic or other form, whether or not marked, designated or otherwise identified as confidential.</p>
        <p>The Confidentiality obligations accepted by the Party shall remain in force for a period of ten (10) years from the end of the Party’s relationship with NeuroLingua.</p>
        <p>The Party shall allow NeuroLingua or its affiliates to collect their personal information or data including, without limitation, its sensitive information, financial information, and such other information as may be necessary for the purpose of this Agreement.</p>
        <p>The Party further consents and allows the NeuroLingua to provide the Party’s personal data to Government agencies and tax authorities as may be required to comply with the applicable law. “Confidential or Proprietary Information” includes all information shared by NeuroLingua with the Party, including but not limited to, any information that is private, secret or confidential in nature concerning NeuroLingua’s customers, users, business, business relationships or financial affairs, documents and methods of teaching, technical know-how, trade secrets, original work of authorship, etc.</p>
        <p>It is agreed by the Party that the party would not disclose the terms of any Agreement signed with NeuroLingua to a third party. In the event of breach of confidentiality obligations, NeuroLingua shall be entitled to take appropriate legal actions, including without limitations, claim for damages, injunctive relief, etc.</p>
        <p>The Party shall additionally agree not to divulge or allow to be divulged to any person any Confidential Information relating to the business or affairs of NeuroLingua save as provided by law or with NeuroLingua’s prior written consent.</p>
        
        <p>Any information that is subject to one of the following exclusions shall not be Confidential or Proprietary Information:</p>
        <p>a{")"}&nbsp;     Information that is or becomes generally available to and known by the public;</p>
        <p>b{")"}&nbsp;     Information that is or becomes</p>
        available to the Recipient on a non-confidential basis from the third party;
        <p>c{")"}&nbsp;     Information that was generated</p>
        independently without reference to the Party’s Confidential Information; or
        <p>d{")"}&nbsp;    Information that is required to be
        disclosed under a court order or pursuant to any applicable governmental rule,
        regulations or statue, provided that the Recipient provide the Party with prior
        written notice of such disclosure, as permitted by law and the timing for
        response set forth in the request.</p>
        <p>All users shall agree to comply with the privacy agreement for users by signing up with the platform.</p>

      </div>
    </div>
  );
};

export default Privacy;
